import React, {useEffect, useRef, useState} from 'react';
import styles from '../css/Audio.module.css';
import { KeyboardArrowDown, PlaylistPlay } from "@mui/icons-material";

import Button from "components/inputs/Button";
import SubTopicAudioListDnd from "./SubTopicAudioListDnd";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { audioActions } from "reducers/audio";
import { setSequence } from "service/util/setSequence";
import AudioService from "../../service/apiConfig/AudioService";
import Swal from "sweetalert2";
import { Switch } from "@mui/material";

const getItemStyle = (isDragging, draggableStyle) => ({
    border: isDragging ? "1px solid #5A54A1FF" : "none",
    boxShadow: isDragging ? "0 4px 5px -2px rgb(192, 192, 192)" : "none",
    background: isDragging ? "#fff" : "#fff",
    ...draggableStyle,
});

const SubTopicDetailDnd = ({ data, index, subTopicList, setSubTopicList }) => {
    const dispatch = useDispatch();
    const contentRef = useRef([]);
    const roomSubTopic = useSelector(state => state.audioData.roomSubTopic);
    const audioDetail = useSelector(state => state.audioData.audioDetail);
    const [audioList, setAudioList] = useState(data.audioList);

    useEffect(() => {
        setAudioList(data.audioList);
    }, [data])

    const onDragEnd = (result) => {
        if (!result.destination) return;
        contentRef.current[index].classList.add(styles.active);
        setAudioList((item) => setSequence(item, result.source.index, result.destination.index));
        setSubTopicList(
            subTopicList.map(sub => sub.id === data.id ? {...sub, audioList: setSequence(audioList, result.source.index, result.destination.index)} : sub)
        )
    };

    const handleHide = (e, index) => {
        contentRef.current[index].classList.toggle(styles.active);
        e.currentTarget.classList.toggle(styles.active);
    }

    const handleOpenModal = (id, roomId, item, create) => {
        if (id) {
            AudioService.getById(id)
                .then(response => {
                    dispatch(audioActions.setAudioDetail(response.data.data));
                    dispatch(audioActions.setRoomSubTopicId({ ...roomSubTopic, id: roomId }));
                    dispatch(audioActions.setOpenModal(true));
                    dispatch(audioActions.setCreate(create));
                })
                .catch(err => console.log(err));
        } else {
            dispatch(audioActions.setAudioDetail(item));
            dispatch(audioActions.setRoomSubTopicId({ ...roomSubTopic, id: roomId }));
            dispatch(audioActions.setOpenModal(true));
            dispatch(audioActions.setCreate(create));
        }
    }

    const onDeleted = (id) => {
        Swal.fire({
            title: '정말 삭제하시겠습니까 ?',
            icon: 'warning',
            confirmButtonText: '네',
            cancelButtonText: '아니오',
            showCancelButton: true,
            confirmButtonColor: '#D55240',
        }).then(result => {
            if (result.isConfirmed) {
                AudioService.deleted(id)
                    .then(response => {
                        const list = audioList.filter(item => item.id !== id);
                        setAudioList(list)
                    })
                    .catch(err => console.log(err));
            }
        });
    }
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={"audioList"}>
                {provided => (
                    <div ref={provided.innerRef} {...provided.droppableProps} {...provided.dragHandleProps}>
                        <li>
                            <div >
                                <h3 onClick={(e) => handleHide(e, index)}>{data.title} <KeyboardArrowDown/></h3>
                            </div>
                            <div className={styles.contentRef} ref={el => contentRef.current[index] = el}>
                                {audioList.length === 1
                                    ? audioList.map((audio, i) => (
                                        <div className={styles.subAudioContainer} key={i}>
                                            <PlaylistPlay />
                                            <img src={audio.thumbnailUrl} alt={audio.imageAltText} />
                                            <div className={styles.subAudioInfo}>
                                                <p>{audio.title}</p>
                                                <span className={"ellipsis2"}>{audio.script}</span>
                                                <audio controls={true} src={audio.audioUrl} />
                                            </div>
                                            <div className={styles.subAudioBtnContainer} >
                                                <div className={"invalidNotice"}>
                                                    <span className={`invalidCircle ${audio.invalid === false ? 'invalid' : ''}`} />
                                                    {audio.invalid === false ? '활성화' : '비활성화'}
                                                </div>
                                                {/*<Switch sx={{ marginLeft: "auto" }} checked={audio.invalid === false || audio.invalid === "false"} disabled />*/}
                                                <div>
                                                    <Button onClick={() => handleOpenModal(audio.id, data.id, audioDetail, false)} style={{ background: "#DFA78F" }}>수정</Button>
                                                    <Button onClick={() => {onDeleted(audio.id)}} style={{ background: "#D55240", marginLeft: "0.2rem" }}>삭제</Button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    : audioList.length > 1 ? (
                                            audioList.map((audio, i) => (
                                                <Draggable draggableId={"audioList" + i} index={i}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            key={"audioList" + i}
                                                            ref={provided.innerRef}
                                                             {...provided.draggableProps}
                                                             style={getItemStyle(
                                                                 snapshot.isDragging,
                                                                 provided.draggableProps.style
                                                             )}
                                                        >
                                                            <SubTopicAudioListDnd provided={provided} index={i} data={audio} deletedAudio={onDeleted} handleOpenModal={() => handleOpenModal(audio.id, data.id, audioDetail, false)} />
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))
                                        )
                                        : (
                                            <div className={styles.subAudioNoData}>
                                                <p>오디오가 없습니다. 등록해주세요.</p>
                                                <Button onClick={() => handleOpenModal(null, data.id, audioDetail, true)} style={{ background: "#a2b521" }}>등록</Button>
                                            </div>
                                        )}
                                {audioList.length >= 1 && <Button className={styles.addBtn} onClick={() => handleOpenModal(null, data.id, audioDetail, true)} style={{ background: "#a2b521" }}>추가</Button>}
                            </div>
                        </li>
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default SubTopicDetailDnd;